import React from 'react'
import PageIntroduciton from '../../component/common/introduction'
import SystemFirstComponent from '../../component/system/SystemFirstComponent'
import SystemSecondComponent from '../../component/system/SystemSecondComponent'
import SystemThirdComponent from '../../component/system/SystemThirdComponent'
import AboutUsFourthComponent from '../../component/aboutus/aboutUsFourthComponent'

const System = () => {
    return (
        <>
            <PageIntroduciton title="INFORMATION" description1='A system is an interconnected set of elements coherently organized' description2='to achieve something or serve a particular function' />
            <SystemFirstComponent />
            <SystemSecondComponent />
            <SystemThirdComponent />
            <AboutUsFourthComponent />
        </>
    )
}

export default System